<template>
  <v-card
    tile
    flat
    color="grey lighten-5"
    v-if="loggedInUser != null && this.pagePermission == true"
  >
    <v-container>
      <v-alert v-if="successMessage != null" dense text type="success">
        {{ successMessage }}
      </v-alert>
      <v-alert v-if="errorMessage != null" dense outlined type="error">
        {{ errorMessage }}
      </v-alert>
      <v-row no-gutters v-if="loggedInUser.type == 'Admin'">
        <v-col>
          <v-btn
            x-small
            rounded
            class="ma-2"
            outlined
            color="green lighten-1"
            @click.stop="loadClientForm('Add')"
          >
            <v-icon left>mdi-plus</v-icon> Client
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-for="(clientId, i) in sortedClients" :key="i">
          <v-card>
            <v-card-title>
              <v-container>
                <v-row>
                  {{ clientStoreData[clientId].name }}
                  <v-menu
                    bottom
                    offset-y
                    :close-on-content-click="false"
                    transition="slide-y-transition"
                    class="d-sm-none"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon small>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item>
                        <v-icon small left>mdi-account</v-icon>
                        <span class="overline">
                          {{ clientStoreData[clientId].liason }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-tooltip right v-if="loggedInUser.type == 'Admin'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              x-small
                              icon
                              class="ma-2"
                              color="primary"
                              @click.stop="
                                loadClientForm(
                                  'Edit',
                                  clientStoreData[clientId]
                                )
                              "
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Client</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-icon small left>mdi-phone</v-icon>
                        <span class="overline">
                          {{ clientStoreData[clientId].phone }}
                        </span>
                      </v-list-item>
                      <v-list-item>
                        <v-icon small left>mdi-email</v-icon>
                        <span class="overline">
                          {{ clientStoreData[clientId].email }}
                        </span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <!-- <v-menu
                    v-if="loggedInUser.type == 'Admin'"
                    bottom
                    offset-y
                    :close-on-content-click="false"
                    transition="slide-y-transition"
                  ></v-menu> -->
                  <v-menu
                    bottom
                    offset-y
                    :close-on-content-click="false"
                    transition="slide-y-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-bind="attrs" v-on="on">
                        <span
                          class="overline"
                          :style="
                            (
                              clientStoreData[clientId].payments +
                              clientStoreData[clientId].credits -
                              clientSummaryData[clientId].billedLabor -
                              clientSummaryData[clientId].billedExpenses
                            ).toFixed(2) >= 0
                              ? 'color:#66BB6A'
                              : 'color:#F44336'
                          "
                          >{{
                            $vuetify.breakpoint.width > 450 ? 'Balance: ' : ''
                          }}${{
                            (
                              clientStoreData[clientId].payments +
                              clientStoreData[clientId].credits -
                              clientSummaryData[clientId].billedLabor -
                              clientSummaryData[clientId].billedExpenses
                            ).toFixed(2)
                          }}
                        </span>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-if="clientStoreData[clientId].payments > 0"
                      >
                        <v-icon small left color="green lighten-1"
                          >mdi-plus</v-icon
                        >
                        <span class="overline">
                          Payments: ${{
                            clientStoreData[clientId].payments.toFixed(2)
                          }}
                        </span>
                      </v-list-item>
                      <v-list-item v-if="clientStoreData[clientId].credits > 0">
                        <v-icon small left color="green lighten-1"
                          >mdi-plus</v-icon
                        >
                        <span class="overline">
                          Credits: ${{
                            clientStoreData[clientId].credits.toFixed(2)
                          }}
                        </span>
                      </v-list-item>
                      <v-list-item
                        v-if="clientSummaryData[clientId].billedLabor > 0"
                      >
                        <v-icon small left color="red">mdi-minus</v-icon>
                        <span class="overline">
                          Billed Labor: ${{
                            clientSummaryData[clientId].billedLabor.toFixed(2)
                          }}
                        </span>
                      </v-list-item>
                      <v-list-item
                        v-if="clientSummaryData[clientId].billedExpenses > 0"
                      >
                        <v-icon small left color="red">mdi-minus</v-icon>
                        <span class="overline">
                          Billed Expenses: ${{
                            clientSummaryData[clientId].billedExpenses.toFixed(
                              2
                            )
                          }}
                        </span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </v-container>
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-expansion-panels flat>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <v-row no-gutters align="center">
                      <v-col cols="4">
                        <v-menu
                          bottom
                          offset-y
                          transition="slide-y-transition"
                          v-if="loggedInUser.type == 'Admin'"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              rounded
                              class="ma-2"
                              outlined
                              color="green lighten-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon left>mdi-plus</v-icon> New
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item>
                              <v-btn
                                small
                                text
                                color="primary"
                                @click.stop="
                                  loadProjectForm('Add', { clientId: clientId })
                                "
                              >
                                Project
                              </v-btn>
                              <v-btn
                                small
                                text
                                color="primary"
                                @click.stop="
                                  loadPaymentForm('Add', { clientId: clientId })
                                "
                              >
                                Payment
                              </v-btn>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="8" align="right">
                        <span class="overline">Projects</span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                      flat
                      tile
                      light
                      v-for="(projectId, j) in projectsByClient[clientId]"
                      :key="j"
                    >
                      <v-divider v-if="j > 0"></v-divider>
                      <v-card-title>
                        <span class="subtitle-2">
                          {{ projectStoreData[projectId].name }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-tooltip left v-if="loggedInUser.type == 'Admin'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              x-small
                              icon
                              class="ma-2"
                              color="primary"
                              @click.stop="
                                loadProjectForm(
                                  'Edit',
                                  projectStoreData[projectId]
                                )
                              "
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit Project</span>
                        </v-tooltip>
                      </v-card-title>
                      <v-card-text>
                        <v-row no-gutters>
                          <v-col>
                            <v-row align="center">
                              <v-col cols="3">
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2">Hours</span>
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2">{{
                                    projectStoreData[projectId].hours.toFixed(2)
                                  }}</span>
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-col>
                              <v-col cols="3">
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2">Expenses</span>
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2"
                                    >${{
                                      projectStoreData[
                                        projectId
                                      ].expenses.toFixed(2)
                                    }}</span
                                  >
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-col>
                              <v-col
                                cols="3"
                                v-if="
                                  projectStoreData[projectId].billedLabor > 0 
                                "
                              >
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2">Billed Labor</span>
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2"
                                    >${{
                                      projectStoreData[
                                        projectId
                                      ].billedLabor.toFixed(2)
                                    }}</span
                                  >
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-col>
                              <v-col
                                cols="3"
                                v-if="
                                  projectStoreData[projectId].billedExpenses > 0
                                "
                              >
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2"
                                    >Billed Expenses</span
                                  >
                                  <v-spacer></v-spacer>
                                </v-row>
                                <v-row no-gutters>
                                  <v-spacer></v-spacer>
                                  <span class="subtitle-2"
                                    >${{
                                      projectStoreData[
                                        projectId
                                      ].billedExpenses.toFixed(2)
                                    }}</span
                                  >
                                  <v-spacer></v-spacer>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          small
                          v-if="
                            loggedInUser.type == 'Admin' ||
                              projectStoreData[projectId].managers[0] ==
                                loggedInUser.id ||
                              projectStoreData[projectId].managers[1] ==
                                loggedInUser.id
                          "
                          text
                          color="primary"
                          @click.stop="loadTaskDialog(projectId)"
                        >
                          Tasks
                        </v-btn>
                        <!-- <v-btn small text color="primary">
                            Files
                          </v-btn> -->
                      </v-card-actions>
                    </v-card>
                    <v-row>
                      <v-spacer></v-spacer>
                      <!-- <v-btn
                        small
                        v-if="loggedInUser.type == 'Admin'"
                        text
                        color="primary"
                        @click.stop="loadPayments(clientId)"
                      >
                        Payments
                      </v-btn> -->
                      <v-btn
                        small
                        text
                        color="primary"
                        @click.stop="loadPayments(clientId)"
                      >
                        Payments
                      </v-btn>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="showClientForm"
      v-if="showClientForm == true"
      max-width="800px"
    >
      <DialogForm
        :action="formAction"
        title="Client"
        :data="clientData"
        @delete-item="loadClientForm('Delete', $event)"
        @update-table="refreshClients"
        @success="successHandler"
        @close="showClientForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showProjectForm"
      v-if="showProjectForm == true"
      max-width="800px"
    >
      <DialogForm
        :action="formAction"
        title="Project"
        :data="projectData"
        @delete-item="loadProjectForm('Delete', $event)"
        @update-table="updateProjects"
        @success="successHandler"
        @close="showProjectForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showPaymentForm"
      v-if="showPaymentForm == true"
      max-width="800px"
    >
      <DialogForm
        :action="formAction"
        title="Payment"
        :data="paymentData"
        @delete-item="loadPaymentForm('Delete', $event)"
        @success="successHandler"
        @close="showPaymentForm = false"
      ></DialogForm>
    </v-dialog>
    <v-dialog
      v-model="showTaskDialog"
      v-if="showTaskDialog == true"
      max-width="800px"
    >
      <div v-if="loadingTasks == true">
        <v-card>
          <v-progress-linear
            :indeterminate="true"
            color="orange darken-4"
          ></v-progress-linear>
          <v-card-text>
            <v-row>
              <v-spacer></v-spacer>
              <span> Loading Tasks </span>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <div v-if="loadingTasks == false">
        <Tasks
          :projectId="projectToLoad"
          :tasksByServiceType="tasksByServiceType[projectToLoad]"
          :tasks="tasks[projectToLoad]"
          @close="showTaskDialog = false"
          @update-tasks="updateTasks"
        ></Tasks>
      </div>
    </v-dialog>
    <v-dialog
      v-model="showPaymentHistory"
      v-if="showPaymentHistory == true"
      max-width="800px"
    >
      <DataTable
        sortby="date"
        :sortbydesc="true"
        title="Payment Submissions"
        :items="paymentSubmissions"
        :headers="paymentHeaders"
        itemtype="Payment Submission"
        :showdaterange="false"
        :showadd="false"
        :loading="loadingPayments"
        loadingtext="Loading Payments"
        @error="errorMessage = $event"
      >
      </DataTable>
    </v-dialog>
  </v-card>
</template>

<script>
import DialogForm from '@/components/DialogForm/DialogForm.vue'
import Tasks from '@/components/Projects/Tasks.vue'
import DataTable from '@/components/DataTable/DataTable.vue'

export default {
  name: 'Projects',
  components: { DialogForm, Tasks, DataTable },
  formAction: null,
  data: () => ({
    pageName: 'Projects',
    showClientForm: false,
    clientData: {},
    projectData: null,
    paymentData: null,
    showProjectForm: false,
    showPaymentForm: false,
    showPaymentHistory: false,
    loading: false,
    loadingText: null,
    successMessage: null,
    errorMessage: null,
    dialogSuccessMessage: null,
    dialogErrorMessage: null,
    sortedClients: [],
    projectsByClient: {},
    projectToLoad: null,
    showTaskDialog: false,
    viewArchived: false,
    tasks: {},
    tasksByServiceType: {},
    loadingTasks: false,
    loadingPayments: false,
    paymentSubmissions: [],
    paymentHeaders: [
      {
        text: 'Date',
        align: 'left',
        value: 'date',
        sortable: true,
      },
      { text: 'Amount', value: 'amount', sortable: false },
      { text: 'Payment Type', value: 'paymentMethod', sortable: false },
      { text: 'Description', value: 'description', sortable: false },
    ],
  }),
  computed: {
    projectStoreData() {
      return this.$store.getters.getProjects
    },
    userStoreData() {
      return this.$store.getters.getUsers
    },
    clientStoreData() {
      return this.$store.getters.getClients
    },
    companyId() {
      return this.$store.getters.getCompanyId
    },
    loggedInUser() {
      return this.$store.getters.getLoggedInUser
    },
    clientSummaryData() {
      let clientBalances = {}
      for (var clientId of Object.keys(this.clientStoreData)) {
        let hours = 0
        let billedLabor = 0
        let expenses = 0
        let billedExpenses = 0
        for (var projectId of this.projectsByClient[clientId]) {
          hours = hours + this.projectStoreData[projectId].hours
          billedLabor =
            billedLabor + this.projectStoreData[projectId].billedLabor
          expenses = expenses + this.projectStoreData[projectId].expenses
          billedExpenses =
            billedExpenses + this.projectStoreData[projectId].billedExpenses
        }
        clientBalances[clientId] = {
          hours: hours,
          billedLabor: billedLabor,
          expenses: expenses,
          billedExpenses: billedExpenses,
        }
      }
      return clientBalances
    },
    pagePermission() {
      let pagePermission = this.$store.getters.getPagePermission
      for (var i = 0; i < pagePermission.length; i++) {
        if (this.pageName == pagePermission[i]) {
          return true
        }
      }
      return false
    },
  },
  watch: {
    clientStoreData() {
      this.refreshClients()
    },
    projectStoreData() {
      this.refreshProjects()
    },
    loggedInUser(newVal, oldVal) {
      if (newVal != null && oldVal == null) {
        this.refreshClients()
        this.refreshProjects()
      }
    },
  },
  methods: {
    successHandler(message) {
      var self = this
      self.successMessage = message
      self.showProjectForm = false
      self.showClientForm = false
      self.showPaymentForm = false
      setTimeout(function() {
        self.successMessage = null
      }, 2000)
    },
    refreshClients() {
      let clientsByName = {}
      let sortedNames = []
      this.sortedClients = []
      for (var cId of Object.keys(this.clientStoreData)) {
        clientsByName[this.clientStoreData[cId].name.toLowerCase()] = cId
      }
      sortedNames = Object.keys(clientsByName).sort()
      for (var cName of sortedNames) {
        this.sortedClients.push(clientsByName[cName])
      }
      this.refreshProjects()
    },
    updateProjects(event) {
      if (event.action == 'add') {
        this.projectsByClient[event.item.clientId].unshift(event.item.id)
      } else if (event.action == 'edit') {
        this.tasks[event.item.id] = null
      }
    },
    sortTasks(projectId) {
      for (var serviceTypeId of Object.keys(
        this.tasksByServiceType[projectId]
      )) {
        let taskList = this.tasksByServiceType[projectId][serviceTypeId]
        if (taskList.length > 0) {
          let completeTasks = []
          let incompleteTasks = []
          for (var taskId of taskList) {
            if (this.tasks[projectId][taskId].completed == false) {
              incompleteTasks.push({
                id: taskId,
                completionDate: this.tasks[projectId][taskId].completionDate,
              })
            } else {
              completeTasks.push({
                id: taskId,
                completionDate: this.tasks[projectId][taskId].completionDate,
              })
            }
          }
          completeTasks = completeTasks.sort(function(a, b) {
            return new Date(a.completionDate) - new Date(b.completionDate)
          })
          incompleteTasks = incompleteTasks.sort(function(a, b) {
            return new Date(a.completionDate) - new Date(b.completionDate)
          })
          let temp = []
          for (var incompleteTask of incompleteTasks) {
            temp.push(incompleteTask.id)
          }
          for (var completeTask of completeTasks) {
            temp.push(completeTask.id)
          }
          this.tasksByServiceType[projectId][serviceTypeId] = temp
        }
      }
    },
    loadTasks(projectId) {
      if (this.tasks[projectId] == null) {
        this.tasks[projectId] = []
        this.tasksByServiceType[projectId] = {}
        for (var serviceType of this.projectStoreData[projectId].serviceTypes) {
          this.tasksByServiceType[projectId][serviceType.id] = []
        }
        let payload = {
          projectId: projectId,
        }
        let self = this
        self.$store.dispatch('getTasks', payload).then(result => {
          if (result.success != true) {
            self.errorMessage = result.data.error.message
          } else {
            self.tasks[projectId] = result.data
            for (var tId of Object.keys(result.data)) {
              self.tasksByServiceType[projectId][
                result.data[tId].serviceType
              ].push(result.data[tId].id)
            }
            self.sortTasks(projectId)
            this.loadingTasks = false
          }
        })
      } else {
        this.loadingTasks = false
      }
    },
    updateTasks(event) {
      if (event.action == 'add') {
        this.tasks[event.item.projectId][event.item.id] = event.item
        this.tasksByServiceType[event.item.projectId][
          event.item.serviceType
        ].push(event.item.id)
        this.sortTasks(event.item.projectId)
      } else if (event.action == 'edit') {
        this.tasks[event.item.Attributes.projectId][event.item.Attributes.id] =
          event.item.Attributes
        this.sortTasks(event.item.Attributes.projectId)
      } else if (event.action == 'delete') {
        let temp = {}
        for (var tId of Object.keys(this.tasks[event.item.projectId])) {
          if (tId != event.item.id) {
            temp[tId] = this.tasks[event.item.projectId][tId]
          }
        }
        this.tasks[event.item.projectId] = temp
        for (
          var i = 0;
          i <
          this.tasksByServiceType[event.item.projectId][event.item.serviceType]
            .length;
          i++
        ) {
          if (
            this.tasksByServiceType[event.item.projectId][
              event.item.serviceType
            ][i] == event.item.id
          ) {
            this.tasksByServiceType[event.item.projectId][
              event.item.serviceType
            ].splice(i, 1)
          }
        }
      }
    },
    loadPayments(clientId) {
      this.paymentSubmissions = []
      this.showPaymentHistory = true
      this.loadingPayments = true
      let payload = {
        clientId: clientId,
      }
      let self = this
      self.$store.dispatch('getPaymentSubmissions', payload).then(result => {
        if (result.success != true) {
          self.errorMessage = result.data.error.message
        } else {
          self.paymentSubmissions = result.data
          this.loadingPayments = false
        }
      })
    },
    refreshProjects() {
      let projectsByName = {}
      let sortedNames = []
      this.projectsByClient = {}
      for (var pId of Object.keys(this.projectStoreData)) {
        projectsByName[this.projectStoreData[pId].name.toLowerCase()] = pId
      }
      sortedNames = Object.keys(projectsByName).sort()
      for (var cId of Object.keys(this.clientStoreData)) {
        this.projectsByClient[cId] = []
      }
      for (var cName of sortedNames) {
        this.projectsByClient[
          this.projectStoreData[projectsByName[cName]].clientId
        ].push(projectsByName[cName])
      }
    },
    loadClientForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.clientData = JSON.parse(JSON.stringify(item))
      }
      this.showClientForm = true
    },
    loadProjectForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.projectData = JSON.parse(JSON.stringify(item))
      }
      this.showProjectForm = true
    },
    loadPaymentForm(action, item) {
      this.formAction = action
      if (item != null) {
        this.paymentData = JSON.parse(JSON.stringify(item))
      }
      this.showPaymentForm = true
    },
    loadTaskDialog(pId) {
      this.projectToLoad = pId
      this.loadingTasks = true
      this.showTaskDialog = true
      this.loadTasks(pId)
    },
    resetErrors() {
      this.errorMessage = null
      this.successMessage = null
      this.dialogSuccessMessage = null
      this.dialogErrorMessage = null
    },
  },
  beforeMount() {
    if (this.loggedInUser != null) {
      this.refreshClients()
      this.refreshProjects()
    }
  },
}
</script>
